import { z } from 'zod';
import { CURRENCIES } from '../money/money';

export const idSchema = z.string().min(1).max(64);

export const moneySchema = z.object({
  amountMinor: z.number().int().refine(Number.isSafeInteger, 'Amount out of range'),
  currency: z.enum(CURRENCIES),
});

/** Every driver-app mutation carries one; the server dedupes on it. */
export const idempotencyKeySchema = z.string().uuid();

/** Kenyan mobile number in E.164, e.g. +254712345678. */
export const kePhoneSchema = z.string().regex(/^\+254(7|1)\d{8}$/, 'Expected a Kenyan mobile number in +254 format');

/** KRA PIN: one letter, nine digits, one letter (e.g. A123456789Z). Uppercased so a stored PIN is always comparable. */
export const kraPinSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]\d{9}[A-Z]$/, 'Expected a KRA PIN: one letter, nine digits, one letter');
